$(document).ready(function () {

    $('.acc-cont-head').on('click', function(){
		const $parent = $(this).parent('.acc-cont');

		if ($parent.hasClass('open')) {
			$parent.removeClass('open');
			$(this).next('.acc-cont-txt').stop().slideUp(300);
		} else {
			$('.acc-cont').removeClass('open');
			$('.acc-cont-txt').stop().slideUp(300);

			$parent.addClass('open');
			$(this).next('.acc-cont-txt').stop().slideDown(300);
		}
	});
    

    // $(".buy-btn").on("click", function () {
    //     $(".modal-conts").fadeIn(); // モーダルをフェードイン
    // });

    $(".modal-cont-close").on("click", function () {
        $(".modal-conts").fadeOut(); // モーダルをフェードアウト
    });

    $(".modal-conts").on("click", function (e) {
        if ($(e.target).is(".modal-conts")) {
            $(".modal-conts").fadeOut(); // 背景クリックで閉じる
        }
    });

    $(window).scroll(function () {
        const windowHeight = $(window).height();
        const scroll = $(window).scrollTop();

        $('.element').each(function () {
            const targetPosition = $(this).offset().top;
            if (scroll > targetPosition - windowHeight + 200) {
                $(this).addClass("is-fadein");
            }
        });

    });

    // 画像を伸ばすように表示
    setTimeout(function () {
        $(".mv-flex-left, .mv-flex-right").css({
            opacity: 1,
            transform: "scaleY(1)" // Y軸方向にスケールを元に戻す
        });

        // mv-titleを少し遅れてフェードイン
        setTimeout(function () {
            $(".mv-title").css({
                opacity: 1
            });
        }, 1250);

    }, 500); // 0.5秒の遅延

});


const smoothScrollTrigger = document.querySelectorAll('a[href^="#"]');

for (let i = 0; i < smoothScrollTrigger.length; i++) {
    smoothScrollTrigger[i].addEventListener('click', (e) => {

        e.preventDefault();
        let href = smoothScrollTrigger[i].getAttribute('href');
        let targetElement = document.getElementById(href.replace('#', ''));

        const rect = targetElement.getBoundingClientRect().top;
        const offset = window.pageYOffset;
        const gap = 60;
        const target = rect + offset - gap;

        window.scrollTo({
            top: target,
            behavior: 'smooth',
        });

    });

}


$(window).on("load scroll resize", function () {

    var st = $(window).scrollTop();
    var wh = $(window).height();

    $('.sec-scroll-point').each(function (i) {
        var tg = $(this).offset().top;
        var id = $(this).attr('id');

        if (st > tg - wh + (wh / 1.25)) {
            $(".header__link").removeClass("active");
            var link = $(".header__link[href *= " + id + "]");
            $(link).addClass("active");
        }
    });

});
